import { Component, h } from 'preact';
import { connect } from 'preact-redux';
import { truncate } from '../util';

class MiniHoroscope extends Component {
    componentWillMount() {
        this.props.requireDailyUpdates();
    }
    render(props) {
        if (!props.horoscope || !props.horoscope.interp) {
            return (
                <mini-horoscope class={props.class}>
                    <h1 class='widget-header'>Loading…</h1>
                </mini-horoscope>
            );
        }
        return (
            <mini-horoscope class={props.class}>
                <h1 class='widget-header'>Today’s Horoscope</h1>
                <hr />
                <div>
                    <a class='text-link-undecorated' href={'/daily-horoscope/' + props.horoscope.sign_slug}>
                        <p>
                            <span class='widget-header'>{props.scope_type}: </span>
                            {truncate(props.horoscope.interp, 130)}
                            <span class='text-link'>read more</span>
                        </p>
                    </a>
                    <br />
                    <a class='button-today' data-action='Click' href={props.href}>{props.button}</a>
                </div>
            </mini-horoscope>
        );
    }
}

const mapStateToProps = (state) => {
    if (state.user.logged_in) {
        return {
            button: 'Today\'s tarot reading',
            horoscope: state['daily-updates'] && state['daily-updates'].horoscope,
            href: '/readings-reports/tarot-readings/daily-reflection',
            scope_type: 'For You',
        };
    }
    return {
        button: 'Get Your Daily Horoscope',
        horoscope: state['daily-updates'] && state['daily-updates'].horoscope,
        href: '#signup',
        scope_type: 'For Everyone',
    };
};

const mapDispatchToProps = (dispatch) => ({
    requireDailyUpdates: () => dispatch({ type: 'daily-updates:required' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(MiniHoroscope);





// WEBPACK FOOTER //
// ./app/components/mini-horoscope.js